import React, {useState} from 'react';
import Navbar from './Navbar';   // dont know why this is here 
import '../Components/hero.css';
import Sidebar from './Sidebar';
import { Link } from 'react-router-dom';


function Hero() {

 
  const [show, setShow] = useState(false);

	const toggle = () => {
		setShow(!show);
	};


  return (
    <div className='container' id='Hero'>           {/*  the id 2 make it jump 2 home when we press the link in sidebar*/}
       <Navbar  toggle={toggle} />   {/*  I think im gonna remove it*/}
       <Sidebar show={show} toggle={toggle}/>
        <div className="content">
            <div className="contentItems">
                <h1>Yummy Desserts</h1>
                <p>Welcome to our cake studio! Our studio is a place where art and taste come together to create unforgettable cakes for all occasions. We believe that a cake is not just a dessert, but a centerpiece that celebrates life's most special moments.</p>
                {/* <div className="btn">Button here</div> */}
                {/* <button className='btn'>Book Now</button>     this works good but will try another down  */}
                <button className="custom-btn btn-anim"><span>Book Now</span></button>
                
                {/* <Link to='https://yandex.com'>       THIS is how i'm gonna link with other page 
                <button className="custom-btn btn-anim"><span>Book Now</span></button> 
                </Link> */}
            </div>
        </div>
      
    </div>
  )
}

export default Hero
